import { action, observable } from 'mobx';
import { FormulaFormVM } from '../template/FormulaFormVM';
import { InlineWaterControlRecordDto, InlineWaterControlRequestDto, InlineWaterControlResponseDto } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { valueToName } from 'cd-eft/utils/stringUtilities';
import { HydraulicFormulaController } from "cd-eft/services/eftSetApi";
import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";
interface IWaterControlForm {
  inletEntry: string,
  pipeLength: string;
  pipeDiameter: string;
  inletManning: string;
  maxPoolElevation: string;
  pipeInletElevation: string;
  weirElevation: string;
  structureInvertElevation: string;
  pipeOutletElevation: string;
  tailwaterElevation: string;
  weirLength: string;
  pipeLengthOut: string;
  pipeDiameterO: string;
  outletManning: string;
}

interface IEntrySelectInterface {
  name: string;
  value: string;
}

export class WaterControlVM extends FormulaFormVM {
  readonly formLabelsForExport;
  readonly resultLabelsForExport;
  constructor(props) {
    super(props); //optional
    this.helpLink = 'https://usdagcc.sharepoint.com/:b:/r/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/General/NETS-Support%20Documents/Formulas%20Documentation/Help%20Select%20n%20Value.pdf?csf=1&web=1&e=ssYi6q';
    this.disablePrintBtn = true;
    this.formLabelsForExport = {
      inletEntry: 'Inlet Entry',
      pipeLength: 'Inlet Pipe Length (ft)',
      pipeDiameter: 'Inlet Pipe Diameter (in)',
      inletManning: `Inlet Manning's n`,
      weirLength: 'Weir Length (in)',
      pipeLengthOut: 'Outlet Pipe Length (ft)',
      pipeDiameterO: 'Outlet Pipe Diameter (in)',
      outletManning: `Outlet Manning's n`,
      maxPoolElevation: 'Maximum Pool Elevation (ft)',
      pipeInletElevation: 'Pipe Inlet Elevation (ft)',
      weirElevation: 'Weir Elevation (ft)',
      structureInvertElevation: 'Structure Inlet Elevation (ft)',
      pipeOutletElevation: 'Pipe Outlet Elevation (ft)',
      tailwaterElevation: 'Tailwater Elevation (ft)',
    }
    this.resultLabelsForExport = {
      discharge: 'Pool Elevation (ft)',
      downStreamElevation: 'Discharge (cfs)',
      poolElevation: 'Water Elevation US of Weir (ft)',
      weirStageElevation: 'Water Elevation DS of Weir (ft)',
    }
  }

  @observable calculationResults: InlineWaterControlRecordDto[] = [];

  @observable savedWaterControlFormData!: IWaterControlForm;
  @observable waterControlFormData: IWaterControlForm = {
    inletEntry: '',
    pipeLength: "0",
    pipeDiameter: "0",
    inletManning: "0",
    maxPoolElevation: "0",
    pipeInletElevation: "0",
    weirElevation: "0",
    structureInvertElevation: "0",
    pipeOutletElevation: "0",
    tailwaterElevation: "0",
    weirLength: "0",
    pipeLengthOut: "0",
    pipeDiameterO: "0",
    outletManning: "0",
  };

  @observable entryOptions: IEntrySelectInterface[] = []

  @observable formValidation = {
    hasError: true,
    inletEntry: false,
    pipeLength: false,
    pipeDiameter: false,
    inletManning: false,
    maxPoolElevation: false,
    pipeInletElevation: false,
    weirElevation: false,
    structureInvertElevation: false,
    pipeOutletElevation: false,
    tailwaterElevation: false,
    weirLength: false,
    pipeLengthOut: false,
    pipeDiameterO: false,
    outletManning: false,
    poolElevation: false,
    discharge: false,
    waterElevationUSofWeir: false,
    waterElevationDSofWeir: false,
    formErrors: {
      inletEntry: '',
      pipeLength: '',
      pipeDiameter: '',
      inletManning: '',
      maxPoolElevation: '',
      pipeInletElevation: '',
      weirElevation: '',
      structureInvertElevation: '',
      pipeOutletElevation: '',
      tailwaterElevation: '',
      weirLength: '',
      pipeLengthOut: '',
      pipeDiameterO: '',
      outletManning: '',
      poolElevation: '',
      discharge: '',
      waterElevationUSofWeir: '',
      waterElevationDSofWeir: '',
    },
  };

  @action.bound waterControlErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }
  
  @action.bound setFixedValue(name, fixed) {
    const event1 = {
      target: {
        name: name,
        value: this.roundingHelperString(fixed, name.includes('manning')? 4 : 2),
      },
    };
    this.handleWaterControlForm(event1, true);
  }

  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }

  @action.bound handleWaterControlForm(event, within?: boolean) {
    const { name } = event.target;
    let value = event.target.value;
    if (!within && name !== 'Inlet-Entry' && value.length > 7) {
      return;
    }

    switch (name) {
      case 'Inlet-Entry':
        this.waterControlFormData.inletEntry = value;
        break;
      case 'pipe-length':
        this.waterControlFormData.pipeLength = value;
        break;
      case 'pipe-diameter':
        this.waterControlFormData.pipeDiameter = value;
        break;
      case 'inlet-manning':
        this.waterControlFormData.inletManning = value;
        break;
      case 'maximum-pool-elevation':
        this.waterControlFormData.maxPoolElevation = value;
        break;
      case 'pipe-inlet-elevation':
        this.waterControlFormData.pipeInletElevation = value;
        break;
      case 'weir-elevation':
        this.waterControlFormData.weirElevation = value;
        break;
      case 'structure-invert-elevation':
        if (value === '') {
          value = 0
        }
        this.waterControlFormData.structureInvertElevation = value;
        break;
      case 'pipe-outlet-elevation':
        if (value === '') {
          value = 0
        }
        this.waterControlFormData.pipeOutletElevation = value;
        break;
      case 'tailwater-elevation':
        if (value === '') {
          value = 0
        }
        this.waterControlFormData.tailwaterElevation = value;
        break;
      case 'weir-length':
        this.waterControlFormData.weirLength = value;
        break;
      case 'pipe-length-out':
        this.waterControlFormData.pipeLengthOut = value;
        break;
      case 'pipe-diameter-out':
        this.waterControlFormData.pipeDiameterO = value;
        break;
      case 'outlet-manning':
        this.waterControlFormData.outletManning = value;
        break;
    }
  }

  @action.bound handleInputOnBlur(name, value) {
    this.validateInput(name, value);
  }

  @action.bound async validateInput(name, value) {
    let valuSet = 0;
    if (name === 'inlet-manning' || name === 'outlet-manning') {
      valuSet = this.roundingHelperNumber(parseFloat(value), 4);
    } else {
      valuSet = this.roundingHelperNumber(parseFloat(value), 2);
    }
    if (name !== 'Inlet-Entry' && !isNaN(value) && value !== '') this.setFixedValue(name, valuSet);

    switch (name) {
      case 'Inlet-Entry':
        if (value === '') {
          this.formValidation.inletEntry = true;
          this.formValidation.formErrors.inletEntry = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_09', undefined, this.formLabelsForExport.inletEntry);
        } else {
          this.formValidation.inletEntry = false;
          this.formValidation.formErrors.inletEntry = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-length':
        if (value === '' || valuSet <= 0) {
          this.formValidation.pipeLength = true;
          this.formValidation.formErrors.pipeLength = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.pipeLength.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.pipeLength = false;
          this.formValidation.formErrors.pipeLength = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-diameter':
        if (value === '' || valuSet < 0.02) {
          this.formValidation.pipeDiameter = true;
          this.formValidation.formErrors.pipeDiameter = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_07');
        } else {
          this.formValidation.pipeDiameter = false;
          this.formValidation.formErrors.pipeDiameter = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'inlet-manning':
        if (value === '' || valuSet <= 0 || valuSet > 1) {
          this.formValidation.inletManning = true;
          this.formValidation.formErrors.inletManning = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_02')
        } else {
          this.formValidation.inletManning = false;
          this.formValidation.formErrors.inletManning = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'maximum-pool-elevation':
        if (value === '' || valuSet <= 0) {
          this.formValidation.maxPoolElevation = true;
          this.formValidation.formErrors.maxPoolElevation = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.maxPoolElevation.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.maxPoolElevation = false;
          this.formValidation.formErrors.maxPoolElevation = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-inlet-elevation':
        if (value === '' || valuSet <= 0) {
          this.formValidation.pipeInletElevation = true;
          this.formValidation.formErrors.pipeInletElevation = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.pipeInletElevation.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.pipeInletElevation = false;
          this.formValidation.formErrors.pipeInletElevation = '';
          this.formValidation.hasError = false;
        }
        break;

      case 'weir-elevation':
        if (value === '' || valuSet <= 0) {
          this.formValidation.weirElevation = true;
          this.formValidation.formErrors.weirElevation = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.weirElevation.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.weirElevation = false;
          this.formValidation.formErrors.weirElevation = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'structure-invert-elevation':
        if (value === '' || valuSet < 0) {
          this.formValidation.structureInvertElevation = true;
          this.formValidation.formErrors.structureInvertElevation = ' ';
          this.formValidation.hasError = true;
          await this.callNegativeError('structureInvertElevation');
        } else {
          this.formValidation.structureInvertElevation = false;
          this.formValidation.formErrors.structureInvertElevation = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-outlet-elevation':
        if (value === '' || valuSet < 0) {
          this.formValidation.pipeOutletElevation = true;
          this.formValidation.formErrors.pipeOutletElevation = ' ';
          this.formValidation.hasError = true;
          await this.callNegativeError('pipeOutletElevation');
        } else {
          this.formValidation.pipeOutletElevation = false;
          this.formValidation.formErrors.pipeOutletElevation = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'tailwater-elevation':
        if (value === '' || valuSet < 0) {
          this.formValidation.tailwaterElevation = true;
          this.formValidation.formErrors.tailwaterElevation = ' ';
          this.formValidation.hasError = true;
          await this.callNegativeError('tailwaterElevation');
        } else {
          this.formValidation.tailwaterElevation = false;
          this.formValidation.formErrors.tailwaterElevation = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'weir-length':
        if (value === '' || valuSet <= 0) {
          this.formValidation.weirLength = true;
          this.formValidation.formErrors.weirLength = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.weirLength.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.weirLength = false;
          this.formValidation.formErrors.weirLength = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-length-out':
        if (value === '' || valuSet <= 0) {
          this.formValidation.pipeLengthOut = true;
          this.formValidation.formErrors.pipeLengthOut = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined, this.formLabelsForExport.pipeLengthOut.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.pipeLengthOut = false;
          this.formValidation.formErrors.pipeLengthOut = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-diameter-out':
        if (value === '' || valuSet < 0.02) {
          this.formValidation.pipeDiameterO = true;
          this.formValidation.formErrors.pipeDiameterO = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_07', undefined);
        } else {
          this.formValidation.pipeDiameterO = false;
          this.formValidation.formErrors.pipeDiameterO = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'outlet-manning':
        if (value === '' || valuSet <= 0 || valuSet > 1) {
          this.formValidation.outletManning = true;
          this.formValidation.formErrors.outletManning = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_02')
        } else {
          this.formValidation.outletManning = false;
          this.formValidation.formErrors.outletManning = '';
          this.formValidation.hasError = false;
        }
        break;
    }
  }

  async callNegativeError(inputName: string) {
    await MessageCenter.addNotificationFromCode("Common_14", undefined, this.formLabelsForExport[inputName]);
  }

  get validateRequiredInputs() {
    if (this.formValidation.inletEntry || this.formValidation.pipeLength || this.formValidation.pipeDiameter
      || this.formValidation.inletManning || this.formValidation.maxPoolElevation || this.formValidation.pipeInletElevation
      || this.formValidation.weirElevation || this.formValidation.weirLength || this.formValidation.pipeLengthOut
      || this.formValidation.pipeDiameterO || this.formValidation.outletManning || this.formValidation.structureInvertElevation
      || this.formValidation.pipeOutletElevation || this.formValidation.tailwaterElevation) {
      return false
    }
    return true
  }
  async validateReqInput() {
    await this.validateInput("Inlet-Entry", this.waterControlFormData.inletEntry);
    await this.validateInput("pipe-length", this.waterControlFormData.pipeLength);
    await this.validateInput("pipe-diameter", this.waterControlFormData.pipeDiameter);
    await this.validateInput("inlet-manning", this.waterControlFormData.inletManning);

    await this.validateInput("maximum-pool-elevation", this.waterControlFormData.maxPoolElevation);
    await this.validateInput("pipe-inlet-elevation", this.waterControlFormData.pipeInletElevation);
    await this.validateInput("weir-elevation", this.waterControlFormData.weirElevation);
    await this.validateInput("structure-invert-elevation", this.waterControlFormData.structureInvertElevation);
    await this.validateInput("pipe-outlet-elevation", this.waterControlFormData.pipeOutletElevation);
    await this.validateInput("tailwater-elevation", this.waterControlFormData.tailwaterElevation);

    await this.validateInput("weir-length", this.waterControlFormData.weirLength);
    await this.validateInput("pipe-length-out", this.waterControlFormData.pipeLengthOut);
    await this.validateInput("pipe-diameter-out", this.waterControlFormData.pipeDiameterO);
    await this.validateInput("outlet-manning", this.waterControlFormData.outletManning);
  }
  @action.bound async computeWaterControl() {
    this.disableComputeBtn = true;
    this.disablePrintBtn = true;
    MessageCenter.blockCalls(['Common_26'])
    await this.validateReqInput();
    if (this.validateRequiredInputs) {
      const requestPayload: InlineWaterControlRequestDto = {
        commonInletDto: {
          inletEntry: this.waterControlFormData.inletEntry,
          manningsN: parseFloat(this.waterControlFormData.inletManning),
          pipeDiameter: parseFloat(this.waterControlFormData.pipeDiameter),
          pipeLength: parseFloat(this.waterControlFormData.pipeLength)
        },
        commonOutletDto: {
          manningsN: parseFloat(this.waterControlFormData.outletManning),
          pipeDiameter: parseFloat(this.waterControlFormData.pipeDiameterO),
          pipeLength: parseFloat(this.waterControlFormData.pipeLengthOut)
        },
        inlineWaterControlElevationDto: {
          maxPoolElev: parseFloat(this.waterControlFormData.maxPoolElevation),
          pipeInletElev: parseFloat(this.waterControlFormData.pipeInletElevation),
          pipeOutletElev: parseFloat(this.waterControlFormData.pipeOutletElevation),
          structureInvertElev: parseFloat(this.waterControlFormData.structureInvertElevation),
          tailwaterElev: parseFloat(this.waterControlFormData.tailwaterElevation),
          weirElev: parseFloat(this.waterControlFormData.weirElevation)
        },
        weirLength: parseFloat(this.waterControlFormData.weirLength)
      }
      try {
        this.disablePrintBtn = true;
        this.disableComputeBtn = true;
        const response = await HydraulicFormulaController.calculateInlineWaterUsingPOST(requestPayload);
        const responsePayload: InlineWaterControlResponseDto = response.data;

        if (this.hasErrorContent(responsePayload.errorResponse)) {
          MessageCenter.addNotification(responsePayload.errorResponse!.errorMessage!, responsePayload.errorResponse!.errorType!, responsePayload.errorResponse!.errorCode,
            responsePayload.errorResponse?.urlPath ? [{
              text: 'Help',
              callback: () => {
                window.open(responsePayload.errorResponse?.urlPath, '_blank');
              }
            }] : undefined)
          this.calculationResults = [];
          this.hasResults = false;
          this.disablePrintBtn = true;
        }
        else {
          this.savedWaterControlFormData = JSON.parse(JSON.stringify(this.waterControlFormData));
          this.calculationResults = responsePayload.inlineWaterControlRecordList ? responsePayload.inlineWaterControlRecordList : [];
          if (this.calculationResults.length > 0) {
            this.disablePrintBtn = false;
            this.hasResults = true;
          }
        }
      }
      catch (error) {
        this.disablePrintBtn = true;
        this.hasResults = false;
        console.error(error);
      }
      finally {
        this.disableComputeBtn = false;
      }
    } else {
      MessageCenter.resetMessageCenter();
      await MessageCenter.addNotificationFromCode('Common_26');
      this.hasResults = false;
      this.disablePrintBtn = true;
    }
    MessageCenter.unblockCalls();
    this.disableComputeBtn = false;
  }

  @action.bound launchAndExport() {
    // disable print button
    this.disablePrintBtn = true;
    this.exportedInputs = [];
    this.exportedResults = [];
    const keys = Object.keys(this.formLabelsForExport);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key === 'inletEntry') {
      this.exportedInputs.push({
      label: this.formLabelsForExport[key],
      value: valueToName(this.waterControlFormData[key])
      })
      }
      else {
      this.exportedInputs.push({
           label: this.formLabelsForExport[key],
           value: this.waterControlFormData[key]
         })
     }
    }
    const tableHeaders = Object.values(this.resultLabelsForExport).join(', ');
    this.exportedResults = this.calculationResults.map((item) => ({ label: tableHeaders, value: item }));
    this.printFormula();
    this.disablePrintBtn = false;
  }
  @action.bound initializeDefaultValues(): void {
    this.waterControlFormData = {
      inletEntry: '',
      pipeLength: this.roundingHelperString(this.defaultValues.commonInletDto.pipeLength, 2),
      pipeDiameter: this.roundingHelperString(this.defaultValues.commonInletDto.pipeDiameter, 2),
      inletManning: this.roundingHelperString(this.defaultValues.commonInletDto.manningsN, 4),
      maxPoolElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.maxPoolElev, 2),
      pipeInletElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.pipeInletElev, 2),
      weirElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.weirElev, 2),
      structureInvertElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.structureInvertElev, 2),
      pipeOutletElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.pipeOutletElev, 2),
      tailwaterElevation: this.roundingHelperString(this.defaultValues.inlineWaterControlElevationDto.tailwaterElev, 2),
      weirLength: this.roundingHelperString(this.defaultValues.weirLength, 2),
      pipeLengthOut: this.roundingHelperString(this.defaultValues.commonOutletDto.pipeLength, 2),
      pipeDiameterO: this.roundingHelperString(this.defaultValues.commonOutletDto.pipeDiameter, 2),
      outletManning: this.roundingHelperString(this.defaultValues.commonOutletDto.manningsN, 4),
    }
    this.savedWaterControlFormData = { ... this.waterControlFormData };
    this.entryOptions = [];
    this.entryOptions = (this.defaultValues.commonInletDto.inletEntry as string[]).map((value, index) => ({
      value: value,
      name: valueToName(value)
    }))
  }
}